import { createFileRoute } from "@tanstack/react-router"
import { MarketingReportingPage } from "@/pages/marketing-reporting"

export const Route = createFileRoute("/(marketing)/marketing/reporting/")({
	component: MarketingReportingPage,
})
